export default __webpack_public_path__ + "static/media/roadmap.189263e4.svg";